import { type CountryCode, ProjectCode } from '@constants'
import { useDialog } from '@dni-hooks/useDialog'
import { type AppEnv } from '@dni-types/vite-env'
import { useApiWordPressLogin } from '@hooks-api/wp/useApiWordPressLogin'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { getDogcatstarPartnerUrl } from '@utils'
import { getAquaCornersPartnerUrl } from '@utils/getAquaCornersPartnerUrl'
import { getHeromamaPartnerUrl } from '@utils/getHeromamaPartnerUrl'
import { getLadynpetPartnerUrl } from '@utils/getLadynpetPartnerUrl'
import { getLitomonPartnerUrl } from '@utils/getLitomonPartnerUrl'
import { getRihshinPartnerUrl } from '@utils/getRihshinPartnerUrl'
import { getYummyTigerPartnerUrl } from '@utils/getYummyTigerPartnerUrl'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'
export const DIALOG_PARTNER_AUTH = 'DIALOG_PARTNER_AUTH'

const getPartnerUrl = (appEnv: AppEnv, projectCode: ProjectCode, countryCode: CountryCode) => {
  if (projectCode === ProjectCode.DCS) return getDogcatstarPartnerUrl(appEnv, countryCode)
  if (projectCode === ProjectCode.LM) return getLitomonPartnerUrl(appEnv, countryCode)
  if (projectCode === ProjectCode.HM) return getHeromamaPartnerUrl(appEnv, countryCode)
  if (projectCode === ProjectCode.YT) return getYummyTigerPartnerUrl(appEnv, countryCode)
  if (projectCode === ProjectCode.AQUA) return getAquaCornersPartnerUrl(appEnv, countryCode)
  if (projectCode === ProjectCode.MNP) return getLadynpetPartnerUrl(appEnv, countryCode)
  if (projectCode === ProjectCode.RS) return getRihshinPartnerUrl(appEnv, countryCode)
  return null
}

interface UseDialogPartnerAuthProps {
  open: boolean
  closeDialog: () => void
  countryCode: CountryCode
  projectCode: ProjectCode
}

export interface DialogPartnerAuthProps {
  countryCode: CountryCode
  projectCode: ProjectCode
  appEnv?: AppEnv
}

export const DialogPartnerAuth = (props: DialogPartnerAuthProps) => {
  const { appEnv, countryCode, projectCode } = props
  const { open, closeDialog } = useDialog<UseDialogPartnerAuthProps>(DIALOG_PARTNER_AUTH)
  const { trigger: wordPressLogin } = useApiWordPressLogin()
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })

  const handleRedirect = async () => {
    if (!appEnv) {
      window.alert(t('cartUi.unableToAccessMerchantSite', { defaultValue: '無法前往經銷專站，請稍後再試' }))
      return
    }
    const redirectUrl = getPartnerUrl(appEnv, projectCode, countryCode)
    try {
      if (!redirectUrl) throw new Error('Redirect Url is null')
      const { data } = await wordPressLogin()
      window.location.href = `${redirectUrl}/auth-processing?token=${data.login_token}`
    }
    catch (error) {
      window.alert(t('cartUi.unableToAccessMerchantSite', { defaultValue: '無法前往經銷專站，請稍後再試' }))
      console.error('wordPressLogin', error)
    }
  }

  return (
    <Dialog open={open} onClose={closeDialog} maxWidth={320}>
      <DialogHeader title={t('cartUi.unableToPerform', { defaultValue: '無法執行本操作' })} />
      <DialogContent>
        <Text>{t('cartUi.goToMerchantSiteTip', { defaultValue: '請經銷夥伴前往經銷專站下單，即可享有您的專屬經銷價！' })}</Text>
      </DialogContent>
      <DialogActions justifyContent="center">
        <Button fullWidth variant="outlined" onClick={closeDialog}>{t('cartUi.gotIt', { defaultValue: '我瞭解了' })}</Button>
        <Button fullWidth onClick={handleRedirect}>{t('cartUi.goToMerchantSite', { defaultValue: '前往經銷專站' })}</Button>
      </DialogActions>
    </Dialog>
  )
}
